import { ChangeEvent } from "react";
import { useNumberMask, useDecimalMask } from "@talladega/hooks";
import { Form } from ".";

type Props = {
  id: string;
  label: string;
  useDecimal?: boolean;
  onChange?: (value: number) => void;
  value?: number;
  maxLength?: number;
  locale?: string;
};

export const NumberInput = ({
  id,
  label,
  useDecimal,
  onChange,
  value,
  maxLength,
  locale = "en",
}: Props) => {
  const { maskPipe: numberMaskPipe, unMaskPipe: numberUnMaskPipe } =
    useNumberMask();
  const { maskPipe: decimalMaskPipe, unMaskPipe: decimalUnMaskPipe } =
    useDecimalMask();

  const unmask = (event: ChangeEvent<HTMLInputElement>) => {
    const { value: v } = event.currentTarget;

    if (onChange) {
      onChange(useDecimal ? decimalUnMaskPipe(v) : numberUnMaskPipe(v));
    }
  };

  const getValue = (valueToCheck: number | undefined | null) => {
    if (valueToCheck === undefined || valueToCheck === null) return undefined;

    return useDecimal
      ? decimalMaskPipe(valueToCheck?.toString(), locale)
      : numberMaskPipe(valueToCheck?.toString(), locale);
  };

  return (
    <Form.Input
      value={getValue(value)}
      id={id}
      label={label}
      maxLength={maxLength}
      onChange={unmask}
    />
  );
};

export default {};
